import { Button, Message, Modal } from '@mairistem/composants';
import React from 'react';

interface CalculImpossibleModalProps {
	onClose: () => void;
}

/**
 * Affichee a la place de la modal de calcul a un gestionnaire qui n'est
 * gestionnaire d'aucun service habilite sur la ligne (ou les lignes du noeud)
 */
const CalculImpossibleModal = ({ onClose }: CalculImpossibleModalProps) => (
	<Modal closeIcon onClose={onClose} open size="small">
		<Modal.Header content="Calcul impossible" />
		<Modal.Content>
			<Message
				content="Aucun des services dont vous êtes gestionnaire n'est habilité sur cette ligne budgétaire : vous ne pouvez pas y effectuer de calcul."
				data-testid="messageCalculImpossible"
				info
			/>
		</Modal.Content>
		<Modal.Actions>
			<Button
				content="Fermer"
				data-testid="closeCalculImpossibleButton"
				onClick={onClose}
			/>
		</Modal.Actions>
	</Modal>
);

export default CalculImpossibleModal;
